// FirstLoginFlow.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import EULAModal from './EULAModal';
import ChangePasswordComponent from './ResetPassword';
import { logout } from '../../store/authSlice';

const FirstLoginFlow = () => {
    const [step, setStep] = useState(1);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    // Retrieve isFirstLogin and signedEula from session storage
    const isFirstLogin = sessionStorage.getItem('isFirstLogin') === 'true';
    const signedEula = sessionStorage.getItem('signedEula') === 'true';
    const handleAgree = () => {
        navigate('/dashboard');
    };

    // const handleChangePassword = async () => {
    //     console.log('Password changed successfully');
    //     dispatch(logout());
    //     navigate('/login');
    // };

    return (
        <Box>
            {!signedEula && (
                <EULAModal 
                    open={step === 1} // EULA
                    onClose={() => setStep(2)} // Password reset
                    onAgree={handleAgree}
                />
            )}
            {/* {signedEula && isFirstLogin && (
                <ChangePasswordComponent onSubmit={handleChangePassword} />
            )} */}
        </Box>
    );
};

export default FirstLoginFlow;